import about from "./about";
import advantage from "./advantage";
import learn from "./learn";
import page from "./page";
import home from "./home";
import security from "./security";
import solution from "./solution";
import price from "./price";
import joinus from "./joinus";
import developer from "./developer";
import common from "./common";
import customer from "./customer";
import application from "./application";
import marketplace from "./marketplace";
import gateway from "./gateway";
import cloudOriginal from "./cloudOriginal";
import pricing from "./pricing";
import guard from "./guard";
import aboutus from "./aboutus";
import partner from "./partner";
import homePage from "./home-page";
import manufacturing from "./manufacturing";
import finance from "./finance";
import open from "./open";
import car from "./car";
import zeroTrust from "./zero-trust";
import identify from "./identify";
import authority from "./authority";
import tenant from "./tenant";
export default {
  about,
  advantage,
  learn,
  page,
  home,
  security,
  solution,
  price,
  joinus,
  developer,
  common,
  customer,
  application,
  marketplace,
  gateway,
  cloudOriginal,
  guard,
  aboutus,
  pricing,
  partner,
  homePage,
  manufacturing,
  finance,
  open,
  car,
  zeroTrust,
  identify,
  tenant,
  authority,
};
